<template>
  <div>
<!--
     <el-button @click="btnClick">弹出</el-button>

     <el-dialog title="添加老师" :visible.sync="dialogAddTeacherVisible" append-to-body @close="dialogClose">
       <SelectUserComponent ref="selectUserCom" class="SelectUserComponent" @selected="selected" @unSelected="unSelected"
        @searchUnSelectClick="searchUnSelectClick"
        @searchSelectClick="searchSelectClick"
        @unSelectPageChange="unSelectPageChange"
        @selectPageChange="selectPageChange"
        :pageSize="5"></SelectUserComponent>
     </el-dialog> -->
     <enter-btn></enter-btn>
  </div>
</template>

<script>
  import enterBtn from '../../components/live/button/entervod_btn.vue'
import SelectUserComponent from '../../components/selectuser/SelectUserComponent.vue'
export default{
  name: 'TestPage',
  components: {
    SelectUserComponent,
    enterBtn
  },
  methods: {
    dialogClose: function () {
      this.$refs.selectUserCom.release()
    },
    btnClick: function () {
      this.dialogAddTeacherVisible = true
    },
    unSelectPageChange: function (pageSize, index) {
      console.log(this.$refs.selectUserCom.getUnSelectCurPage())
    },
    selectPageChange: function (pageSize, index) {
      console.log(this.$refs.selectUserCom.getSelectCurPage())
    },
    searchUnSelectClick: function (val) {
      console.log('selectSearch:' + val)
    },
    searchSelectClick: function (val) {
      console.log('unselectSearch:' + val)
    },
    selected: function (item) {
      // 请求服务器操作
      this.$refs.selectUserCom.selectedSuccess(item)
    },
    unSelected: function (item) {
      // 请求服务器操作
      this.$refs.selectUserCom.unSelectedSuccess(item)
    }
  },
  mounted: function () {
    // 模拟数据
    let list = []
    for (let i = 0; i < 50; i++) {
      let item = {
        Id: i,
        Name: 'stu' + i,
        Mobile: '15801523721'
      }
      list.push(item)
    }
    // this.$refs.selectUserCom.setUnSelectList(list, 100)
    // this.$refs.selectUserCom.setSelectList(null, 100)
  },
  data () {
    return {
      dialogAddTeacherVisible: false
    }
  }
}
</script>

<style scoped>
  .SelectUserComponent{
    width: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/page/test/TestPage.vue